import React from "react";

interface ClearIconProps {
	className?: string;
	ariaHidden?: boolean;
}

export function ClearIcon({
	className = "",
	ariaHidden = true,
}: ClearIconProps) {
	return (
		<span className={className} aria-hidden={ariaHidden}>
			{/* biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon, hidden via the parent span's aria-hidden */}
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M18 6L6 18M6 6L18 18"
					stroke="#68707F"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</span>
	);
}
